import React, {useEffect, useState} from 'react';
import {callEmptyParamsApi} from "../../../connection/ClientApi";
import Urls from "../../../connection/Urls";
import ProductList from "../product/ProductList";
import VerticalImageSlider from "../../../components/imageSlider/VerticalImageSlider";
import ImageSlider from "../../../components/imageSlider/ImageSlider";
import ImageList from "../../../components/imageList/ImageList";
import DoubleImageList from "../../../components/imageList/DoubleImageList";
import GridImageList from "../../../components/imageList/GridImageList";
import messages from "res/messages/farsi";
import {useHistory} from "react-router-dom";
import {IsLargePc, IsMediumPc} from "my-styles/media/media";
import ArticleList from "../article/ArticleList";
import { Helmet } from 'react-helmet';

export const DYNAMIC_DATA_TYPES = {
    PRODUCT: "1",
    IMAGE_SLIDER: "2",
    IMAGE_LIST: "3",
    VERTICAL_IMAGE_SLIDER: "4",
    TITLE_PRODUCT: "5",
    SPECIAL_PRODUCT: "6",
    WHEEL_PRODUCT: "7",
    TITLE_IMAGE_LIST: "8",
    ARTICLE: "9",
    TopBanner: "10",
}

export default function Home(props) {

    const history = useHistory()

    const [isCancelled, setIsCancelled] = useState(false)
    const [dynamicData, setDynamicData] = useState([])

    const onAllClicked = (line) => {
        if (line) {
            if (line.data) {
                if (line.data.indexOf("category") !== -1) {
                    props.onNavigate(history, '/category?type=' + line.type + "&c=" + line.data.split("=")[1] + "&p=1")
                } else if (line.data.indexOf("manufacturer") !== -1) {
                    props.onNavigate(history, '/category?type=' + line.type + "&m=" + line.data.split("=")[1] + "&p=1")
                } else {
                    props.onNavigate(history, '/category?type=' + line.type + "&p=1")
                }
            } else {
                props.onNavigate(history, '/category?type=' + line.type + "&p=1")
            }
        }
    }

    function requestDynamicData() {
        callEmptyParamsApi(Urls.getHomeDynamicData, (data) => {
            if (isCancelled) return

            setDynamicData(data.dynamic_data)
        }, () => {
            setDynamicData([])
            props.onAlert(messages.responseCodeIsNot200)
        }, () => {
            props.onLoading(true)
        }, () => {
            props.onLoading(false)
        })
    }

    function manageSliderType(dynamic) {
        let width = 100
        if (dynamic.related_lines) {
            if (dynamic.related_lines.length === 2) {
                width = 70
            } else if (dynamic.related_lines.length === 4) {
                width = 60
            }
        }

        let pageWidth = window.innerWidth - 50
        let sliderWidth = pageWidth * (width / 100)
        let boxHeight = sliderWidth * (dynamic.lines[0].height / 100)

        let boxHeightOffset = 100
        if (dynamic.header.show_type === "0") {
            if (dynamic.related_lines.length === 2) {
                boxHeightOffset = 97
            } else if (dynamic.related_lines.length === 4) {
                boxHeightOffset = 100
            }
        } else {
            if (dynamic.related_lines.length === 2) {
                boxHeightOffset = 98
            } else if (dynamic.related_lines.length === 4) {
                boxHeightOffset = 96
            }
        }

        let slider = dynamic.header.show_type === "0" ?
            getHorizontalImageSlider(dynamic.lines) :
            getVerticalImageSlider(dynamic.lines)
        let sliderBox = <div style={{width: sliderWidth, height: boxHeight}}>
            {slider}
        </div>

        let images = <div style={{width: pageWidth - sliderWidth, height: boxHeight}}>
            {dynamic.related_lines.length === 2 &&
                getReatedDoubleImageList(
                    dynamic.header,
                    dynamic.related_lines,
                    boxHeight,
                    boxHeightOffset)
            }
            {dynamic.related_lines.length === 4 &&
                getReatedGridImageList(
                    dynamic.header,
                    dynamic.related_lines,
                    boxHeight,
                    boxHeightOffset)
            }
        </div>

        let box = <div className="horizontalFullScreen">{sliderBox}{images}</div>
        if (dynamic.header.show_type !== "0") {
            box = <div className="horizontalFullScreen">{images}{sliderBox}</div>
        }
        return <div className="marginTopMedium">
            {(dynamic.related_lines && dynamic.related_lines.length > 0) ?
                <div>{box}</div> :
                <div>{slider}</div>
            }
        </div>
    }

    function manageImageListType(dynamic) {
        return <div style={{marginBottom: "1em"}}>
            {dynamic.header.show_type === "0" ?
                getHorizontalImageList(dynamic) :
                getGridImageList(dynamic.header, dynamic.lines)
            }
        </div>
    }

    function manageArticleList(dynamic) {

        if (!dynamic.header) {
            return <div/>
        } else {
            return <div className="marginTopBottomSmall">
                {(dynamic.lines && dynamic.lines.length > 0) &&
                    <div className="fullWidth">
                        {getArticleList(dynamic)}
                    </div>
                }
            </div>
        }

    }

    function manageProductListType(dynamic) {
        let productBoxHeight = IsLargePc() ? 400 : IsMediumPc() ? 360 : 320
        if (dynamic.header.show_type === "1") {
            productBoxHeight = IsLargePc() ? 430 : IsMediumPc() ? 390 : 350
        }

        let width = 100;
        if (dynamic.related_lines) {
            if (dynamic.related_lines.length === 2) {
                width = 70
            } else if (dynamic.related_lines.length === 4) {
                width = 60
            }
        }

        let pageWidth = window.innerWidth;
        let productWidth = pageWidth * (width / 100)

        if (dynamic.header.linesIsEmpty) {
            return <div/>
        } else {
            return <div className="marginTopBottomSmall">
                {(dynamic.related_lines && dynamic.related_lines.length > 0) ?
                    <div className="horizontalFullScreen">
                        <div style={{width: productWidth, height: productBoxHeight}}>
                            {getProductList(dynamic)}
                        </div>
                        <div className="marginRightSmall"
                             style={{width: pageWidth - productWidth, height: productBoxHeight}}>
                            {dynamic.related_lines.length === 2 &&
                                getReatedDoubleImageList(
                                    dynamic.header,
                                    dynamic.related_lines,
                                    productBoxHeight,
                                    98)
                            }
                            {dynamic.related_lines.length === 4 &&
                                getReatedGridImageList(
                                    dynamic.header,
                                    dynamic.related_lines,
                                    productBoxHeight,
                                    100)
                            }
                        </div>
                    </div> :
                    <div className="fullWidth" style={{height: productBoxHeight}}>
                        {getProductList(dynamic, 'homeProductList')}
                    </div>
                }
            </div>
        }
    }

    function getProductList(dynamic, type = null) {
        if (dynamic !== undefined && dynamic.lines.length > 0) {
            return <ProductList
                {...props}
                data={dynamic}
                dataType={type}
                onAllClicked={() => {
                    onAllClicked(dynamic.lines[0])
                }}
                onListIsEmpty={(emptyDynamic) => {
                    dynamicData.map((data) => {
                        if (data && data.header && emptyDynamic) {
                            if (data.header.id === emptyDynamic.header.id) {
                                data.header.linesIsEmpty = true
                            }
                        }
                        return data
                    })
                    setDynamicData(dynamicData)
                }}/>
        }
    }

    function getArticleList(dynamic) {
        if (dynamic !== undefined && dynamic.lines.length > 0) {
            return <div>
                <ArticleList
                    {...props}
                    data={dynamic}
                    onListIsEmpty={(emptyDynamic) => {
                        dynamicData.map((data) => {
                            if (data && data.header && emptyDynamic) {
                                if (data.header.id === emptyDynamic.header.id) {
                                    data.header.linesIsEmpty = true
                                }
                            }
                            return data
                        })
                        setDynamicData(dynamicData)
                    }}/>
            </div>
        }
    }

    function getHorizontalImageSlider(lines) {
        if (lines !== undefined && lines.length > 0) {
            return <ImageSlider
                sliders={getImageListInfo(lines)}
                onClicked={(slider) => {
                    props.onBannerClicked(history, slider)
                }}/>
        }
    }

    function getVerticalImageSlider(lines) {
        if (lines !== undefined && lines.length > 0) {
            return <VerticalImageSlider
                sliders={getImageListInfo(lines)}
                onClicked={(slider) => {
                    props.onBannerClicked(history, slider)
                }}/>
        }
    }

    function getHorizontalImageList(dynamic) {
        if (dynamic.lines !== undefined && dynamic.lines.length > 0) {
            return <div>
                <ImageList
                    header={dynamic.header}
                    list={getImageListInfo(dynamic.lines)}
                    sliders={getImageListInfo(dynamic.lines)}
                    onClicked={(item) => {
                        if (item.data.includes("amp;")) {
                            item.data = item.data.replace("amp;", "")
                        }
                        props.onBannerClicked(history, item)
                    }}/>
            </div>
        }
    }

    function getGridImageList(header, lines) {
        if (lines !== undefined && lines.length > 0) {
            return <div>
                <ImageList
                    isGrid={true}
                    header={header}
                    list={getImageListInfo(lines)}
                    onClicked={(item) => {
                        props.onBannerClicked(history, item)
                    }}/>
            </div>
        }
    }

    function getReatedDoubleImageList(header, lines, boxHeight, boxHeightOffset) {
        if (lines !== undefined && lines.length > 0) {
            return <DoubleImageList
                boxHeight={boxHeight}
                boxHeightOffset={boxHeightOffset}
                isGrid={true}
                header={header}
                list={getImageListInfo(lines)}
                onClicked={(item) => {
                    props.onBannerClicked(history, item)
                }}/>
        }
    }

    function getReatedGridImageList(header, lines, boxHeight, boxHeightOffset) {
        if (lines !== undefined && lines.length > 0) {
            return <GridImageList
                boxHeight={boxHeight}
                boxHeightOffset={boxHeightOffset}
                list={getImageListInfo(lines)}
                onClicked={(item) => {
                    props.onBannerClicked(history, item)
                }}/>
        }
    }

    function getImageListInfo(lines) {
        return lines.map((line) => {
            return {
                id: line.id,
                image: line.image,
                width: line.width,
                height: line.height,
                type: line.type,
                data: line.data,
                margin_right: line.margin_right,
                margin_left: line.margin_left,
            }
        })
    }

    function getRowServerStyle(header) {
        return {
            marginTop: header.margin_top + "px",
            marginBottom: header.margin_bottom + "px",
            marginLeft: header.margin_left + "px",
            marginRight: header.margin_right + "px"
        }
    }

    useEffect(() => {
        localStorage.setItem("onlineRefrenceId", "")
        requestDynamicData()

        return () => {
            setIsCancelled(true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    let dynamicItems = dynamicData.map((dynamic, index) => {
        if (dynamic.header.type === DYNAMIC_DATA_TYPES.IMAGE_SLIDER) {
            return <div key={index} style={getRowServerStyle(dynamic.header)}>{manageSliderType(dynamic)}</div>
        } else if (dynamic.header.type === DYNAMIC_DATA_TYPES.IMAGE_LIST) {
            return <div key={index} style={getRowServerStyle(dynamic.header)}>{manageImageListType(dynamic)}</div>
        } else if (dynamic.header.type === DYNAMIC_DATA_TYPES.PRODUCT) {
            return <div key={index} style={getRowServerStyle(dynamic.header)}>{manageProductListType(dynamic)}</div>
        } else if (dynamic.header.type === DYNAMIC_DATA_TYPES.ARTICLE) {
            return <div key={index} style={getRowServerStyle(dynamic.header)}>{manageArticleList(dynamic)}</div>
        } else {
            return null
        }
    })
    return (
        <div className="center" style={{overflow: "hidden", width: "98.5%", marginRight: "1%"}}>
            <Helmet>
                <title>صرفه مارکت</title>
                <meta name="description"
                      content="در فروشگاه اینترنتی صرفه مارکت تلاش داریم با شعار سریع، آسان، مطمئن با صرفه در کوتاه ترین زمان ممکن، با امکان انتخاب ساده و آسان محصولات در اپلیکیشن و یا وب سایت و با اطمینان از کیفیت مناسب کالا، خریدی با قیمت مناسب و با صرفه را برای شما خریدار محترم به ارمغان بیاوریم"/>
                <meta property="og:title" content="فروشگاه اینترنتی صرفه مارکت"/>
                <meta property="og:description"
                      content="در فروشگاه اینترنتی صرفه مارکت تلاش داریم با شعار سریع، آسان، مطمئن با صرفه در کوتاه ترین زمان ممکن، با امکان انتخاب ساده و آسان محصولات در اپلیکیشن و یا وب سایت و با اطمینان از کیفیت مناسب کالا، خریدی با قیمت مناسب و با صرفه را برای شما خریدار محترم به ارمغان بیاوریم"/>
                <meta property="og:image" content="%PUBLIC_URL%/favicon.ico"/>
                <meta property="og:url" content="https://sarfemarket.ir/"/>
                <meta name="theme-color" content="#000000"/>
                <meta name="enamad" content="61528164"/>
                <meta name="google-site-verification" content="a7UDcP_j_QBlp1S7KGeczLTlvDmYkzvwyBo7Qa-qbH0"/>
            </Helmet>
            {dynamicItems}
        </div>
    )
}